import moment from "moment"
import { apolloVuexListStoreFactory } from '../../../libs/ApolloVuexListStore'

import { EVENTS_CATEGORIES_QUERY } from "./graphql";

/* eslint-disable no-unused-vars */
let store = apolloVuexListStoreFactory({
  settings: {
    fetchAllQuery: EVENTS_CATEGORIES_QUERY,
    fetchAllFieldName: 'eventcategories',
  },
})
/* eslint-enable no-unused-vars */

export default store

